module.exports = __webpack_public_path__ + "static/img/Testimonialx.1d13865.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Testimonialx.png
// module id = XzBc
// module chunks = 36